module.exports = __webpack_public_path__ + "50c1dddf8fbd126a4cdbadada7d9d444.svg";